import { Injectable } from '@angular/core';
import {Observable, Subject} from 'rxjs';
import {HttpFilterService} from './http/http-filter.service';

@Injectable({
  providedIn: 'root'
})
export class FilterHandlerService {

  private outSignal = new Subject();
  private outSystemSignal = new Subject();
  private reloadDataSignal = new Subject();
  private populateSignal = new Subject();
  private filters: Array<any>;
  private selects: Array<any>;
  private fullText: string;

  private filterRelevanceOrder = ['stav_projektu', 'termin_realizace_do', 'oblast', 'rozpocet', 'mestska_cast'];

  constructor(
      private httpFilter: HttpFilterService,
  ) {
    this.selects = [];
    this.filters = [];
    this.fullText = '';
  }

  updateSelectedFilters(filters) {
    this.filters = filters;
    this.trimFilters();
    this.outSignal.next({filters: this.filters, fullText: this.fullText});
  }

  onSystemFilterChange(): Observable<any> {
    return this.outSystemSignal.asObservable();
  }

  onFilterChange(): Observable<any> {
    return this.outSignal.asObservable();
  }
  onReloadDataSignal(): Observable<any> {
    return this.reloadDataSignal.asObservable();
  }
  onPopulateSignal(): Observable<any> {
    return this.populateSignal.asObservable();
  }
  sendReloadDataSignal(): void {
    this.reloadDataSignal.next();
  }

  getFilters() {
    return this.filters;
  }

  private trimFilters() {
    for ( const filter in this.filters) {
      if (this.filters[filter].length === 0) {
        delete this.filters[filter];
      }
    }
  }

  /** Odsud dál jsou teď relevantní funkce */

  getCurrentSelects() {
    return this.selects;
  }

  getNextSelectOptions(alias: string, relevantMark: number) {
    const sendThis = {alias, filters: []};
    for ( let i = 0; i <= relevantMark - 1; i++ ) {
      if (this.filters[this.filterRelevanceOrder[i]]) {
        sendThis.filters.push(Object.assign({}, this.filters[this.filterRelevanceOrder[i]]));
      }
    }
    if (alias === 'termin_realizace_do') {
     this.getEndYearSelect();
    } else {
      this.httpFilter.getSelectOptionByAliasAndFiltres(sendThis).subscribe((select) => {
        this.selects[alias] = select.body;
        this.outSystemSignal.next(this.selects);
      });
    }

  }

  getEndYearSelect() {
    this.httpFilter.getEndYearSelect().subscribe((select) => {
      const key = 'termin_realizace_do';
      this.selects[key] = select.body;
      this.outSystemSignal.next(this.selects);
    });
  }

  populateFilterByNameAndValue(filterKey: string, optionId: any) {
    this.populateSignal.next({filterKey, optionId});
  }

  setFullText(fullText: string) {
    this.fullText = fullText;
    this.outSignal.next({filters: this.filters, fullText: this.fullText});
    this.reloadDataSignal.next();
    this.fullText = '';
  }

  getFulltext() {
    return this.fullText;
  }
}
